<template>
  <div
    class="detail"
    vkshop-event-scope="detail"
    v-loading="loading"
  >
    <div class="detail-content">
      <div class="container">
        <div class="bar-title">
          <breadcrumb
            :paths="paths"
            v-if="paths.length"
          ></breadcrumb>
        </div>
        <div class="detail-title clearfix">
          <div class="header-img">
            <img
              v-if="goodsGroup.urls"
              :src="goodsGroup.urls[activeImgIndex]"
              alt=""
            >
          </div>
          <div class="info">
            <div class="info-title">{{goodsGroup.goodsGroupName}}</div>
            <div class="info-text">{{goodsGroup.sellingPoint}}</div>

            <div class="sale-module">
              <div class="price-module">
                <span class="price">￥{{chooseCourse.nowPrice}}</span>
              </div>
              <div
                class="promotion-module clearfix"
                v-if="chooseCourse.promotionList && chooseCourse.promotionList.length !== 0"
              >
                <span class="sale-title">赠品</span>
                <ul class="option-items">
                  <template v-for="promotion in chooseCourse.promotionList">
                    <li
                      class="gift"
                      v-for="giftPackage in promotion.giftPackageList"
                      :key="giftPackage.giftPackageId"
                    >
                      <span>{{giftPackage.giftPackageName}}</span>
                      <span v-if="checkedGiftNumber(giftPackage.giftList)">（已赠完）</span>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
            <div
              class="split-module"
              v-if="chooseCourse.nowPrice > 5000"
            >
              <span class="split-title">拆分付</span>
              <span
                class="split-btn"
                :class="{'split-btn-checked': type ==='split'}"
                @click="checkedSplit"
              >拆分金额付款</span>
              <div class="img-hover-module">
                <img src="@/assets/images/detail/question.svg" />
                <div class="hover-info">针对单笔支付限额问题，您可选择将该订单金额自动拆分为多笔支付，每笔可单独支付，但订单不拆分，订单支付完成时间以拆分的每笔金额均支付完成时间为准。</div>
              </div>
            </div>
            <a
              class="buy-btn"
              herf="javascript:;"
              @click="buyNow"
              vkshop-event-name="buyNow"
              :vkshop-event-param="'coursePackId=' + chooseCourse.coursePackId"
              vkshop-event-type="click"
            >{{type === "split" ? '我要拆分购买' : '立即购买'}}</a>
          </div>
        </div>
        <div
          class="production-img-list"
          v-if="goodsGroup.urls.length > 1"
        >
          <img
            :class="{'active': activeImgIndex === index}"
            v-for="(url, index) in goodsGroup.urls"
            :key="index"
            :src="url"
            @click="changeImg(index)"
          >
        </div>
        <div style="margin-bottom:40px"></div>
      </div>
      <div class="stick-module">
        <sticky
          v-if="!isStudentCenterApp"
          @change="fixedChange"
          class="stickCenter"
        >
          <el-scrollbar :native="false">
            <div class="tabs">
              <div class="containerNav tab-container">
                <div
                  v-for="v in goodsGroup.goodsGroupModels"
                  :key="v.goodsGroupModelId"
                  class="tab"
                  :class="{'tab-active' : showPage == v.goodsGroupModelId}"
                  @click="jumpContFn(v.goodsGroupModelId)"
                  vkshop-event-name="courseIntroduction"
                  vkshop-event-type="click"
                >{{v.modelName}}</div>
                <a
                  v-if="fixed"
                  class="buy-btn"
                  herf="javascript:;"
                  @click="buyNow"
                  vkshop-event-name="buyNow"
                  :vkshop-event-param="'coursePackId=' + chooseCourse.coursePackId"
                  vkshop-event-type="click"
                >{{type === "split" ? '我要拆分购买' : '立即购买'}}</a>
              </div>
            </div>
          </el-scrollbar>
        </sticky>
        <div v-else>
          <el-scrollbar :native="false">
            <div class="tabs">
              <div class="containerNav tab-container">
                <div
                  v-for="v in goodsGroup.goodsGroupModels"
                  :key="v.goodsGroupModelId"
                  class="tab"
                  :class="{'tab-active' : showPage == v.goodsGroupModelId}"
                  @click="jumpContFn(v.goodsGroupModelId)"
                  vkshop-event-name="courseIntroduction"
                  vkshop-event-type="click"
                >{{v.modelName}}</div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>

      <div
        class="container tab-detail"
        id="container"
      >
        <div
          v-for="v in goodsGroup.goodsGroupModels"
          :key="v.goodsGroupModelId"
          v-html="v.details"
          :id="v.goodsGroupModelId"
          style="margin-bottom:15px"
        >
        </div>
      </div>
    </div>
    <choose-child
      :visible.sync="dialogVisible"
      :list="studentList"
      :id.sync="studentId"
      @sure="sureStudent"
    ></choose-child>
  </div>
</template>
<script>
import chooseChild from './chooseChild.vue'
import breadcrumb from '@/components/breadcrumb.vue'
import sticky from '@/components/sticky.vue'
import { loginIn } from '@/util/auth'
export default {
  name: 'detail',
  data() {
    return {
      showPage: 0,
      loading: true,
      goodsGroup: {},
      coursePack: {},
      chooseCourse: {},
      activeImgIndex: 0,
      parentId: this.$cookies.get('parentId'),
      studentList: [],
      dialogVisible: false,
      paths: [],
      fixed: false,
      studentId: '',
      type: 'default', // 拆单
      isStudentCenterApp: window.navigator.userAgent.includes('VIPKID') && window.navigator.userAgent.includes('PCStudent') // 用来判断是否在学习中心app
    }
  },
  created() {
    if (this.$route.params.id == 88) {
      this.$router.replace({ name: 'detail', params: { id: 106 } })
      location.reload()
      return
    }
    this.initPaths()
    this.getDetail()
  },
  methods: {
    initPaths() {
      // 学习中心app 禁止跳转到首页
      if (this.isStudentCenterApp) {
        this.paths = [{
          name: '课程包系列'
        }]
      } else {
        this.paths = [{
          name: '课程包系列',
          href: '/shop/index'
        }]
      }
    },
    getDetail() {
      this.axios({
        method: 'get',
        url: '/mall/api/goodsGroup/display/details/id',
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.goodsGroup = res.data.data
          this.chooseCourse = this.goodsGroup.coursePackList[0]
          this.showPage = this.goodsGroup.goodsGroupModels[0].goodsGroupModelId;
          this.paths.push({
            name: this.goodsGroup.goodsGroupName,
            herf: ''
          })
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })
    },
    changeImg(index) {
      this.activeImgIndex = index
    },
    buyNow() {
      if (!this.parentId) {
        loginIn()
      } else {
        this.getChilds()
      }
    },
    // 获取家长下的学生
    getChilds() {
      this.axios({
        method: 'get',
        url: '/mall/api/userCenter/student/getStudentsByParentId',
        params: {
          parentId: this.parentId
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.studentList = res.data.data.map(item => {
            return { id: item.id, name: item.englishName, avatar: item.avatar }
          })
        }
        if (this.studentList.length > 1) {
          this.studentId = this.$cookies.get('studentId')
          this.dialogVisible = true
        } else {
          this.studentId = this.studentList[0].id
          this.sureStudent()
        }
      })
    },
    sureStudent() {
      // 校验
      this.axios({
        method: 'post',
        url: '/mall/api/packorder/before/order/check',
        data: {
          studentId: this.studentId,
          coursePackId: this.chooseCourse.coursePackId,
          goodsGroupId: this.goodsGroup.id,
          payType: 1
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.$router.push(`/createPackorder/${this.chooseCourse.coursePackId}/${this.goodsGroup.id}/${this.studentId}?type=${this.type}`)
        } else if ([3005, 3040, 3042].includes(res.data.code)) {
          this.$alert(res.data.msg)
        } else if (res.data.code === 1028) {
          this.$confirm({
            content: res.data.data.msg,
            cancelBtnText: '取消',
            sureBtnText: '确定'
          }).then(() => {
            window.location.href = window.location.origin + res.data.data.url;
          }).catch(err => { })
        } else if (res.data.code === 1024) {
          this.$confirm({
            content: res.data.data.msg,
            cancelBtnText: '我的订单',
            sureBtnText: '去支付'
          }).then(() => {
            this.$router.push({ path: '/order/list' })
          }).catch(err => {
            this.$router.push({ path: '/order/list' })
          })
        }
      })
    },
    fixedChange(boolean) {
      this.fixed = boolean
    },
    // 检查库存
    checkedGiftNumber(giftList) {
      return giftList.some(gift => {
        return gift.giftSellOut
      })
    },
    // 点击拆分金额付款
    checkedSplit() {
      this.type = this.type === 'default' ? 'split' : 'default'
    },
    //详情页锚点滚动
    scrollFn(currentY, targetY, id) {
      let needScrollTop = targetY - currentY
      const per = needScrollTop / 8
      let currentY2 = currentY;
      currentY2 += per;
      setTimeout(() => {
        if (Math.abs(Math.abs(currentY2) - Math.abs(targetY)) > 10) {
          window.scrollTo(0, currentY2)
          this.scrollFn(currentY2, targetY, id)
        } else {
          window.scrollTo(0, targetY)
          this.showPage = id;
        }
      }, 5)
    },
    jumpContFn(id) {
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      let oShowContTop = document.getElementById(id).offsetTop - 60;
      this.scrollFn(currentY, oShowContTop, id)
    }
  },
  updated() {
    this.$nextTick(function () {
      //监听锁定锚点title
      let oContainer = document.getElementById('container');
      let aDetails = oContainer.children;
      let arrDetails = [];
      for (let i = 0;i < aDetails.length;i++) {
        let idAlone = aDetails[i].getAttribute('id');
        let oft = document.getElementById(idAlone).offsetTop - 60;
        arrDetails.push({
          id: idAlone,
          oft
        })
      }
      let timer;
      let that = this;
      window.onscroll = function () {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(function () {
          let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
          for (let i = 0;i < arrDetails.length;i++) {
            if ((scrollTop >= arrDetails[i].oft && (i + 1) == arrDetails.length) || (scrollTop >= arrDetails[i].oft && scrollTop < arrDetails[i + 1].oft)) {
              that.showPage = arrDetails[i].id;
              return
            }
          }
        }, 5)
      }
    })
  },
  components: {
    chooseChild,
    breadcrumb,
    sticky
  }
}
</script>
<style lang="less" scoped>
.detail {
  .detail-content {
    .bar-title {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      margin: 26px 0 24px;
      padding: 0 30px;
      .bread-crumbs {
        color: #999;
        &:hover {
          font-weight: 600;
        }
      }
    }
    .detail-title {
      padding: 0 30px;
      .header-img {
        height: 445px;
        width: 445px;
        margin-right: 30px;
        float: left;
        img {
          height: 100%;
          width: 100%;
        }
      }
      .info {
        float: left;
        width: 589px;
        .info-title {
          font-size: 32px;
          line-height: 45px;
          color: #333;
          margin-bottom: 16px;
        }
        .info-text {
          font-size: 18px;
          line-height: 25px;
          color: #f85415;
          margin-bottom: 24px;
        }
        .sale-module {
          background-color: #f8f8f8;
          padding: 8px;
          margin-bottom: 16px;
          .price-module {
            height: 45px;
            line-height: 45px;
            margin-bottom: 8px;
            span {
              display: inline-block;
              &.price {
                float: left;
                color: #f85415;
                font-size: 32px;
                margin-right: 15px;
                font-weight: 600;
              }
              &.price-old {
                float: left;
                font-size: 18px;
                color: #999999;
                text-decoration: line-through;
              }
            }
          }
          .promotion-module {
            margin-bottom: 8px;
            .sale-title {
              // float: left;
              display: inline-block;
              height: 24px;
              width: 72px;
              line-height: 22px;
              border: 1px solid #f85415;
              color: #f85415;
              font-size: 14px;
              text-align: center;
              margin-right: 16px;
            }
            .option-items {
              max-width: 485px;
              float: left;
              line-height: 25px;
              li {
                font-size: 18px;
                display: inline-block;
                color: #333333;
                margin-right: 18px;
              }
            }
          }
        }
        .split-module {
          user-select: none;
          span {
            display: inline-block;
            &.split-title {
              height: 25px;
              width: 72px;
              line-height: 25px;
              margin-right: 16px;
              font-size: 18px;
              color: #999999;
              letter-spacing: 6px;
            }
            &.split-btn {
              height: 40px;
              width: 128px;
              line-height: 38px;
              font-size: 16px;
              color: #333333;
              border: 1px solid #a9a9a9;
              text-align: center;
              cursor: pointer;
              &.split-btn-checked {
                border-color: #f85415;
                color: #f85415;
              }
            }
          }
          .img-hover-module {
            position: relative;
            display: inline-block;
            margin-left: 16px;
            height: 16px;
            width: 16px;
            img {
              height: 16px;
              width: 16px;
              cursor: pointer;
            }
            .hover-info {
              display: none;
              box-sizing: border-box;
              position: absolute;
              right: -244px;
              top: -44px;
              font-size: 12px;
              background-color: #fff;
              padding: 12px 10px;
              width: 228px;
              height: 108px;
              line-height: 17px;
              color: #333;
              box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06),
                0px 15px 40px 0px rgba(0, 0, 0, 0.12);
              &::before {
                content: " ";
                position: absolute;
                left: -8px;
                top: 50%;
                margin-top: -8px;
                width: 0;
                height: 0;
                border-width: 8px 8px 8px 0;
                border-style: solid;
                border-color: transparent #fff transparent transparent;
              }
            }
            &:hover {
              .hover-info {
                display: block;
              }
            }
          }
        }
        .service {
          font-size: 18px;
          line-height: 36px;
          .service-name {
            color: #999999;
            display: inline-block;
          }
          .service-items {
            color: #333;
            display: inline-block;
            li {
              display: inline-block;
              margin-left: 16px;
            }
          }
        }
        .buy-btn {
          display: block;
          background-color: #f85415;
          color: #fff;
          width: 210px;
          height: 52px;
          box-shadow: 0px 0px 10px 0px rgba(255, 103, 26, 0.2),
            0px 5px 10px 0px rgba(255, 103, 26, 0.4);
          border-radius: 26px;
          font-size: 18px;
          line-height: 52px;
          text-align: center;
          margin-top: 40px;
          cursor: pointer;
          &:hover {
            background-color: #e64507;
            box-shadow: 0 0 10px 0 rgba(255, 103, 26, 0.3),
              0 5px 10px 0 rgba(255, 103, 26, 0.6);
          }
        }
      }
    }
    .production-img-list {
      text-align: center;
      width: 445px;
      padding: 0 20px;
      margin-top: 16px;
      img {
        display: inline-block;
        margin: 0 8px;
        height: 65px;
        width: 65px;
        cursor: pointer;
        border: 2px solid transparent;
        &.active {
          border: 2px solid #f85415;
        }
      }
    }
    .stick-module {
      max-width: 1124px;
      min-width: 1124px;
      width: 1124px;
      margin: 0 auto;
      padding: 0 30px;
      .stickCenter {
        width: 100%;
      }
    }

    .tabs {
      box-sizing: border-box;
      height: 60px;
      width: 100%;
      margin: 0 auto;
      .containerNav {
        min-width: 100%;
        height: 100%;
        display: inline-block;
        white-space: nowrap;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        background-color: #f8f8f8;
        &.tab-container {
          position: relative;
          .buy-btn {
            display: block;
            position: absolute;
            right: 30px;
            top: 9px;
            padding: 0 16px;
            height: 40px;
            line-height: 40px;
            background: rgba(248, 84, 21, 1);
            border-radius: 20px;
            color: #fff;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
          }
        }
      }
      .tab {
        height: 100%;
        box-sizing: border-box;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        line-height: 60px;
        padding: 0 38px;
        color: #333333;
        font-size: 16px;
        position: relative;
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        &.tab-active {
          background-color: #fff;
          color: #f85415;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: -1px;
            height: 4px;
            background-color: #f85415;
          }
          &::before {
            content: "";
            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;
            height: 2px;
            background-color: #fff;
            z-index: 10;
          }
        }
        // &:last-child {
        //   border-right: 1px solid #e5e5e5;
        // }
      }
    }
    .tab-detail {
      padding: 0 30px;
      .title-h2 {
        font-size: 20px;
        margin-top: 40px;
      }
      /deep/ img {
        width: 100%;
      }
    }
  }
}
</style>
